import createDataReducer from "../../helpers/createDataReducer";
import deltas from "../../actions/deltas";

const {
    SET_PAYMENTS_PAGINATION_DATA,
} = deltas.actionTypes;

export default createDataReducer(
    SET_PAYMENTS_PAGINATION_DATA,
);
